<template>
  <v-card hover @click="$router.push('/tracks?date=' + date)" style="cursor: pointer; display: flex; flex-direction: column;">
    <v-card-title style="padding-bottom: 5px;">
      <i class="fad fa-map-marker-alt" style="margin-right: 10px;"></i>
      {{ $t("tracks.header") }}
    </v-card-title>
    
    <div v-if="!loaded" style="text-align: center; height: 150px; display: flex; align-items: center; justify-content: center;">
      <v-progress-circular indeterminate></v-progress-circular>
    </div>
    <div v-else-if="tracksForDate.length === 0" style="text-align: center; height: 150px; display: flex; align-items: center; justify-content: center; padding: 20px;">
      <p style="color: grey;">{{ $t("fitness.no_data_here") }}</p>
    </div>
    <div v-else style="flex-grow: 1;">
      <v-card-text>
        <v-layout row wrap style="margin: 0;">
          <v-flex xs6 style="text-align: center; padding: 10px;">
            <i class="fad fa-route fa-2x" style="color: var(--v-primary-base); margin-bottom: 10px;"></i>
            <div style="font-size: 16px; font-weight: bold;">{{ tracksForDate.length }}</div>
            <div style="font-size: 12px; color: grey; line-height: 1.2;">{{ $t("tracks.header") }}</div>
          </v-flex>
          <v-flex xs6 style="text-align: center; padding: 10px;">
            <i class="fad fa-map fa-2x" style="color: var(--v-primary-base); margin-bottom: 10px;"></i>
            <div style="font-size: 16px; font-weight: bold;">{{ formattedDistance }} <span style="font-size: 12px; font-weight: normal;">km</span></div>
            <div style="font-size: 12px; color: grey; line-height: 1.2;">{{ $t("tracks.distance") }}</div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import { storage } from "../../schmucklicloud";
var numeral = require("numeral");

export default {
  props: {
    date: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loaded: false,
      tracksForDate: [],
      totalDistance: 0
    };
  },
  computed: {
    formattedDistance() {
      return numeral(this.totalDistance / 1000).format("0.00").replace(/,/g, "'");
    }
  },
  watch: {
    date() {
      this.loadData();
    }
  },
  mounted() {
    this.loadData();
  },
  methods: {
    async loadData() {
      this.loaded = false;
      this.tracksForDate = [];
      this.totalDistance = 0;
      
      // Since tracks do not store a string date in an indexed column consistently for simple query,
      // we'll fetch recently added tracks and filter by start_time being on the current date.
      // Usually, tracks are not thousands, so fetching all or a large chunk is OK.
      var response = await storage.getAll("tracks", [], 0, 100);
      
      if (response.isOK && response.data !== undefined) {
        let targetDate = new Date(this.date);
        
        response.data.forEach(track => {
          if (track.data.start_time) {
            let trackDate = new Date(parseInt(track.data.start_time));
            if (
              trackDate.getFullYear() === targetDate.getFullYear() &&
              trackDate.getMonth() === targetDate.getMonth() &&
              trackDate.getDate() === targetDate.getDate()
            ) {
              this.tracksForDate.push(track);
              if (track.data.calc_distance) {
                this.totalDistance += parseFloat(track.data.calc_distance);
              }
            }
          }
        });
      }
      this.loaded = true;
    }
  }
};
</script>
